export enum CATALOGS_SIDEBAR_VIEWS {
  HELPER = 'HELPER',
  HISTORY = 'HISTORY'
}
